import { Button } from "@material-ui/core";
import { useStyles } from "./button-navbar-styles";
import classNames from "classnames";
import { forwardRef } from "react";

interface ButtonNavbarProps {
    children: React.ReactNode;
    onClick: undefined | (() => void);
    className?: string;
}

export const ButtonNavbar = forwardRef<HTMLButtonElement, ButtonNavbarProps>(({ children, onClick, className, ...props }: ButtonNavbarProps, ref) => {
    const classes = useStyles();
    return (
        <Button onClick={onClick} {...props} className={classNames(classes.button, className)} ref={ref}>
            {children}
        </Button>
    )
})